"use client";

import { useState, useEffect } from "react";
import CategoryHeader from "./CategoryHeader";
import FilterSidebar from "./FilterSidebar";
import ServiceCard from "./ServiceCard";
import BreadcrumbNav from "./BreadcrumbNav";
import SortDropdown from "./SortDropdown";
import Icon from "../../../components/ui/AppIcon";

interface Service {
  id: string;
  name: string;
  category: string;
  area: string;
  rating: number;
  reviewCount: number;
  phone: string;
  whatsapp: string;
  image: string;
  alt: string;
  verified: boolean;
  description: string;
  openNow: boolean;
}

const CategoryListingsInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedArea, setSelectedArea] = useState("All Areas");
  const [selectedRating, setSelectedRating] = useState(0);
  const [selectedSort, setSelectedSort] = useState("relevance");
  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [displayCount, setDisplayCount] = useState(12);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const mockServices: Service[] = [
    {
      id: "1",
      name: "Rajdhani Restaurant",
      category: "Restaurants & Cafes",
      area: "Station Road",
      rating: 4.5,
      reviewCount: 127,
      phone: "+919876543210",
      whatsapp: "919876543210",
      image: "https://images.pexels.com/photos/262978/pexels-photo-262978.jpeg",
      alt: "Modern restaurant interior with wooden tables and warm lighting",
      verified: true,
      description:
        "Authentic North Indian cuisine with family-friendly ambiance. Known for delicious thalis and fresh rotis.",
      openNow: true,
    },
    {
      id: "2",
      name: "City Hospital & Diagnostic Center",
      category: "Healthcare",
      area: "Hospital Area",
      rating: 4.8,
      reviewCount: 243,
      phone: "+919876543211",
      whatsapp: "919876543211",
      image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d",
      alt: "Clean modern hospital reception area with medical staff at desk",
      verified: true,
      description:
        "24/7 emergency services, experienced doctors, and modern diagnostic facilities. Multi-specialty hospital.",
      openNow: true,
    },
    {
      id: "3",
      name: "Bright Future Academy",
      category: "Education",
      area: "College Road",
      rating: 4.6,
      reviewCount: 89,
      phone: "+919876543212",
      whatsapp: "919876543212",
      image:
        "https://images.pixabay.com/photo/2017/08/01/08/29/people-2563491_1280.jpg",
      alt: "Students studying in bright classroom with teacher at whiteboard",
      verified: true,
      description:
        "Coaching classes for competitive exams. Experienced faculty with proven track record of success.",
      openNow: false,
    },
    {
      id: "4",
      name: "Fashion Hub",
      category: "Shopping",
      area: "Main Market",
      rating: 4.3,
      reviewCount: 156,
      phone: "+919876543213",
      whatsapp: "919876543213",
      image:
        "https://images.pexels.com/photos/1884581/pexels-photo-1884581.jpeg",
      alt: "Colorful clothing store with racks of traditional and modern outfits",
      verified: true,
      description:
        "Latest fashion trends for men, women, and kids. Ethnic wear and western collection available.",
      openNow: true,
    },
    {
      id: "5",
      name: "Tech Solutions",
      category: "Professional Services",
      area: "Station Road",
      rating: 4.7,
      reviewCount: 78,
      phone: "+919876543214",
      whatsapp: "919876543214",
      image: "https://images.unsplash.com/photo-1497366216548-37526070297c",
      alt: "Professional office workspace with computers and modern furniture",
      verified: true,
      description:
        "Computer repair, software installation, and IT consulting services. Quick and reliable solutions.",
      openNow: true,
    },
    {
      id: "6",
      name: "Auto Care Center",
      category: "Automotive",
      area: "Bus Stand",
      rating: 4.4,
      reviewCount: 134,
      phone: "+919876543215",
      whatsapp: "919876543215",
      image:
        "https://images.pixabay.com/photo/2017/03/27/14/56/auto-2179220_1280.jpg",
      alt: "Professional mechanic working on car engine in clean workshop",
      verified: true,
      description:
        "Complete car servicing, repairs, and spare parts. Experienced mechanics and genuine parts.",
      openNow: true,
    },
    {
      id: "7",
      name: "Glow Beauty Salon",
      category: "Beauty & Wellness",
      area: "Main Market",
      rating: 4.9,
      reviewCount: 201,
      phone: "+919876543216",
      whatsapp: "919876543216",
      image:
        "https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg",
      alt: "Modern beauty salon interior with styling chairs and mirrors",
      verified: true,
      description:
        "Premium beauty treatments, hair styling, and spa services. Expert beauticians and quality products.",
      openNow: true,
    },
    {
      id: "8",
      name: "Spice Garden Restaurant",
      category: "Restaurants & Cafes",
      area: "College Road",
      rating: 4.2,
      reviewCount: 98,
      phone: "+919876543217",
      whatsapp: "919876543217",
      image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
      alt: "Cozy restaurant with wooden decor and people dining at tables",
      verified: false,
      description:
        "Multi-cuisine restaurant with Chinese, Indian, and Continental dishes. Great ambiance for families.",
      openNow: true,
    },
    {
      id: "9",
      name: "Wellness Clinic",
      category: "Healthcare",
      area: "Railway Colony",
      rating: 4.5,
      reviewCount: 167,
      phone: "+919876543218",
      whatsapp: "919876543218",
      image:
        "https://images.pixabay.com/photo/2017/10/04/09/56/laboratory-2815641_1280.jpg",
      alt: "Medical professional examining patient in clean clinic room",
      verified: true,
      description:
        "General physician, pediatrics, and preventive healthcare. Affordable consultation and medicines.",
      openNow: false,
    },
    {
      id: "10",
      name: "Smart Kids School",
      category: "Education",
      area: "Naya Tola",
      rating: 4.7,
      reviewCount: 112,
      phone: "+919876543219",
      whatsapp: "919876543219",
      image:
        "https://images.pexels.com/photos/8613089/pexels-photo-8613089.jpeg",
      alt: "Young children engaged in learning activities in colorful classroom",
      verified: true,
      description:
        "Play school and primary education with modern teaching methods. Focus on overall development.",
      openNow: false,
    },
    {
      id: "11",
      name: "Electronics Bazaar",
      category: "Shopping",
      area: "Purana Bazar",
      rating: 4.1,
      reviewCount: 145,
      phone: "+919876543220",
      whatsapp: "919876543220",
      image: "https://images.unsplash.com/photo-1498049794561-7780e7231661",
      alt: "Electronics store displaying laptops, phones and gadgets on shelves",
      verified: false,
      description:
        "Latest mobile phones, laptops, and home appliances. Competitive prices and warranty support.",
      openNow: true,
    },
    {
      id: "12",
      name: "Legal Associates",
      category: "Professional Services",
      area: "College Road",
      rating: 4.6,
      reviewCount: 67,
      phone: "+919876543221",
      whatsapp: "919876543221",
      image:
        "https://images.pixabay.com/photo/2017/07/10/23/49/club-2492011_1280.jpg",
      alt: "Professional lawyer in office with law books and documents",
      verified: true,
      description:
        "Legal consultation for civil, criminal, and property matters. Experienced advocates and quick service.",
      openNow: true,
    },
  ];

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:245:6" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="245" data-component-end-line="252" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%20pt-16%20lg%3Apt-20%22%7D" className="min-h-screen bg-background pt-16 lg:pt-20">
        <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:246:8" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="246" data-component-end-line="251" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20py-8%22%7D" className="container mx-auto px-4 py-8">
          <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:247:10" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="247" data-component-end-line="250" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-pulse%20space-y-4%22%7D" className="animate-pulse space-y-4">
            <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:248:12" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="248" data-component-end-line="248" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-12%20bg-muted%20rounded-lg%20w-full%22%7D" className="h-12 bg-muted rounded-lg w-full"></div>
            <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:249:12" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="249" data-component-end-line="249" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-64%20bg-muted%20rounded-lg%20w-full%22%7D" className="h-64 bg-muted rounded-lg w-full"></div>
          </div>
        </div>
      </div>
    );
  }

  const categoryMap: { [key: string]: string } = {
    all: "All Services",
    restaurants: "Restaurants & Cafes",
    healthcare: "Healthcare",
    education: "Education",
    shopping: "Shopping",
    services: "Professional Services",
    automotive: "Automotive",
    beauty: "Beauty & Wellness",
  };

  const filteredServices = mockServices.filter((service) => {
    const categoryMatch =
      selectedCategory === "all" ||
      service.category === categoryMap[selectedCategory];
    const areaMatch =
      selectedArea === "All Areas" || service.area === selectedArea;
    const ratingMatch = service.rating >= selectedRating;
    return categoryMatch && areaMatch && ratingMatch;
  });

  const sortedServices = [...filteredServices].sort((a, b) => {
    switch (selectedSort) {
      case "rating":
        return b.rating - a.rating;
      case "reviews":
        return b.reviewCount - a.reviewCount;
      case "distance":
        return a.area.localeCompare(b.area);
      default:
        return 0;
    }
  });

  const displayedServices = sortedServices.slice(0, displayCount);
  const hasMore = displayCount < sortedServices.length;

  return (
    <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:294:4" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="294" data-component-end-line="398" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%20pt-16%20lg%3Apt-20%22%7D" className="min-h-screen bg-background pt-16 lg:pt-20">
      <BreadcrumbNav data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:295:6" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="295" data-component-end-line="295" data-component-file="CategoryListingsInteractive.tsx" data-component-name="BreadcrumbNav" data-component-content="%7B%22elementName%22%3A%22BreadcrumbNav%22%7D" currentCategory={categoryMap[selectedCategory]} />

      <CategoryHeader data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:297:6" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="297" data-component-end-line="302" data-component-file="CategoryListingsInteractive.tsx" data-component-name="CategoryHeader" data-component-content="%7B%22elementName%22%3A%22CategoryHeader%22%7D"
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
      />

      <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:304:6" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="304" data-component-end-line="397" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20py-6%22%7D" className="container mx-auto px-4 py-6">
        <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:305:8" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="305" data-component-end-line="325" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20mb-6%22%7D" className="flex items-center justify-between mb-6">
          <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:306:10" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="306" data-component-end-line="320" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-4%22%7D" className="flex items-center space-x-4">
            <button data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:307:12" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="307" data-component-end-line="313" data-component-file="CategoryListingsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22lg%3Ahidden%20flex%20items-center%20space-x-2%20px-4%20py-2.5%20bg-brand-primary%20text-white%20rounded-lg%20font-cta%20font-semibold%20hover%3Abg-opacity-90%20transition-all%20duration-300%22%7D"
              onClick={() => setIsFilterOpen(true)}
              className="lg:hidden flex items-center space-x-2 px-4 py-2.5 bg-brand-primary text-white rounded-lg font-cta font-semibold hover:bg-opacity-90 transition-all duration-300"
            >
              <Icon data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:311:14" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="311" data-component-end-line="311" data-component-file="CategoryListingsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22FilterIcon%22%7D" name="FilterIcon" size={18} variant="outline" />
              <span data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:312:14" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="312" data-component-end-line="312" data-component-file="CategoryListingsInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Filters%22%7D">Filters</span>
            </button>
            <p data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:314:12" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="314" data-component-end-line="319" data-component-file="CategoryListingsInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-body%20text-sm%20text-muted-foreground%22%2C%22textContent%22%3A%22services%20found%22%7D" className="font-body text-sm text-muted-foreground">
              <span data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:315:14" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="315" data-component-end-line="317" data-component-file="CategoryListingsInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-semibold%20text-foreground%22%7D" className="font-semibold text-foreground">
                {sortedServices.length}
              </span>{" "}
              services found
            </p>
          </div>
          <SortDropdown data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:321:10" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="321" data-component-end-line="324" data-component-file="CategoryListingsInteractive.tsx" data-component-name="SortDropdown" data-component-content="%7B%22elementName%22%3A%22SortDropdown%22%7D"
            selectedSort={selectedSort}
            onSortChange={setSelectedSort}
          />
        </div>

        <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:327:8" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="327" data-component-end-line="396" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-6%22%7D" className="flex gap-6">
          <FilterSidebar data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:328:10" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="328" data-component-end-line="335" data-component-file="CategoryListingsInteractive.tsx" data-component-name="FilterSidebar" data-component-content="%7B%22elementName%22%3A%22FilterSidebar%22%7D"
            selectedArea={selectedArea}
            onAreaChange={setSelectedArea}
            selectedRating={selectedRating}
            onRatingChange={setSelectedRating}
            isOpen={isFilterOpen}
            onClose={() => setIsFilterOpen(false)}
          />

          <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:337:10" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="337" data-component-end-line="395" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%22%7D" className="flex-1">
            {displayedServices.length === 0 ? (
              <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:339:14" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="339" data-component-end-line="364" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20py-16%22%7D" className="text-center py-16">
                <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:340:16" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="340" data-component-end-line="347" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-24%20h-24%20bg-muted%20rounded-full%20flex%20items-center%20justify-center%20mx-auto%20mb-4%22%7D" className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:341:18" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="341" data-component-end-line="346" data-component-file="CategoryListingsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22SearchIcon%22%2C%22className%22%3A%22text-muted-foreground%22%7D"
                    name="SearchIcon"
                    size={40}
                    variant="outline"
                    className="text-muted-foreground"
                  />
                </div>
                <h3 data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:348:16" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="348" data-component-end-line="350" data-component-file="CategoryListingsInteractive.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-headline%20font-bold%20text-xl%20text-foreground%20mb-2%22%2C%22textContent%22%3A%22No%20services%20found%22%7D" className="font-headline font-bold text-xl text-foreground mb-2">
                  No services found
                </h3>
                <p data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:351:16" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="351" data-component-end-line="353" data-component-file="CategoryListingsInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-body%20text-muted-foreground%20mb-6%22%2C%22textContent%22%3A%22Try%20adjusting%20your%20filters%20or%20search%20criteria%22%7D" className="font-body text-muted-foreground mb-6">
                  Try adjusting your filters or search criteria
                </p>
                <button data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:354:16" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="354" data-component-end-line="363" data-component-file="CategoryListingsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-6%20py-3%20bg-brand-primary%20text-white%20rounded-lg%20font-cta%20font-semibold%20hover%3Abg-opacity-90%20transition-all%20duration-300%22%2C%22textContent%22%3A%22Reset%20All%20Filters%22%7D"
                  onClick={() => {
                    setSelectedCategory("all");
                    setSelectedArea("All Areas");
                    setSelectedRating(0);
                  }}
                  className="px-6 py-3 bg-brand-primary text-white rounded-lg font-cta font-semibold hover:bg-opacity-90 transition-all duration-300"
                >
                  Reset All Filters
                </button>
              </div>
            ) : (
              <>
                <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:367:16" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="367" data-component-end-line="381" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                  className={
                    viewMode === "grid"
                      ? "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6"
                      : "space-y-4"
                  }
                >
                  {displayedServices.map((service) => (
                    <ServiceCard data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:375:20" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="375" data-component-end-line="379" data-component-file="CategoryListingsInteractive.tsx" data-component-name="ServiceCard" data-component-content="%7B%22elementName%22%3A%22ServiceCard%22%7D"
                      key={service.id}
                      service={service}
                      viewMode={viewMode}
                    />
                  ))}
                </div>

                {hasMore && (
                  <div data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:384:18" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="384" data-component-end-line="391" data-component-file="CategoryListingsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mt-8%22%7D" className="text-center mt-8">
                    <button data-component-id="src/app/category-listings/components/CategoryListingsInteractive.tsx:385:20" data-component-path="src/app/category-listings/components/CategoryListingsInteractive.tsx" data-component-line="385" data-component-end-line="390" data-component-file="CategoryListingsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-8%20py-3%20bg-brand-primary%20text-white%20rounded-lg%20font-cta%20font-semibold%20hover%3Abg-opacity-90%20hover%3Ashadow-glow%20transition-all%20duration-300%20transform%20hover%3Ascale-98%22%2C%22textContent%22%3A%22Load%20More%20Services%22%7D"
                      onClick={() => setDisplayCount(displayCount + 12)}
                      className="px-8 py-3 bg-brand-primary text-white rounded-lg font-cta font-semibold hover:bg-opacity-90 hover:shadow-glow transition-all duration-300 transform hover:scale-98"
                    >
                      Load More Services
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryListingsInteractive;
